import { Col, Modal, Row, Space, Spin, Tabs } from "antd";
import { useEffect, useMemo, useState } from "react";
import apiFactory from "../../../api";
import { useInfoUser } from "../../../store/UserStore";
import { CustomAvatar } from "../../avatar/CustomAvatar";

const modalLoadingStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "150px",
};

const VoterTabsModal = ({ open, onCancel, title, voteData = [] }) => {
  const { user, languageMap } = useInfoUser();
  const [loading, setLoading] = useState(false);

  const [votersInfo, setVotersInfo] = useState({});

  const allUserIds = useMemo(() => {
    const uniqueUserIds = new Set();

    if (voteData) {
      voteData?.forEach((option) => {
        option?.userIds?.forEach((id) => uniqueUserIds?.add(id));
      });
    }

    return Array.from(uniqueUserIds);
  }, [voteData]);

  useEffect(() => {
    const fetchAllVotersInfo = async () => {
      if (!allUserIds || allUserIds.length === 0) {
        setVotersInfo({});
        return;
      }

      try {
        setLoading(true);

        const rs = await apiFactory.userApi.listUserById(allUserIds);

        if (rs?.status === 200 && rs.data) {
          const infoMap = rs?.data?.reduce((acc, currentVoter) => {
            acc[currentVoter?.userId] = currentVoter;
            return acc;
          }, {});

          setVotersInfo(infoMap);
        }
      } catch (error) {
        console.error("Failed to fetch user voted info:", error);
        setVotersInfo({});
      } finally {
        setLoading(false);
      }
    };

    if (open) {
      fetchAllVotersInfo();
    }
  }, [allUserIds, open]);

  const renderTabPane = (userIds) => (
    <Row
      gutter={[16, 16]}
      style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}
    >
      {userIds?.length > 0 ? (
        userIds?.map((userId) => {
          const voter = votersInfo?.[userId];

          if (!voter) return null;

          return (
            <Col key={voter?.userId} xs={8} sm={6} md={6} lg={4}>
              <Space
                direction="vertical"
                align="center"
                style={{ width: "100%" }}
              >
                <CustomAvatar person={voter} styleCss={{}} />

                <div className="flex justify-center items-center text-center">
                  <span
                    className={`text-xs break-words ${
                      voter.userId === user?.userId
                        ? "font-bold text-[#0091FF]"
                        : ""
                    }`}
                    style={{ wordBreak: "break-word" }}
                  >
                    {voter?.userId === user?.userId
                      ? languageMap?.["chat.role.conversation.you"] ?? "You"
                      : voter.name || "DELETED MEMBER"}
                  </span>
                </div>
              </Space>
            </Col>
          );
        })
      ) : (
        <Space direction="vertical" align="center" style={{ width: "100%" }}>
          <div className="flex justify-center items-center text-center">
            <span className={`break-words`}>No voter</span>
          </div>
        </Space>
      )}
    </Row>
  );

  const tabItems = useMemo(() => {
    return voteData.map((option) => ({
      key: option?.optionId,
      label: `${option?.optionName} (${option?.userIds?.length})`,
      children: renderTabPane(option?.userIds),
    }));
  }, [voteData, votersInfo, user]);

  return (
    <Modal
      width={600}
      title={title}
      open={open}
      onCancel={onCancel}
      footer={null}
    >
      {loading ? (
        <div style={modalLoadingStyle}>
          <Spin />
        </div>
      ) : (
        <Tabs defaultActiveKey={voteData[0]?.optionId} items={tabItems} />
      )}
    </Modal>
  );
};

export default VoterTabsModal;
